module.exports = __webpack_public_path__ + "static/media/vehicleimagenotavailable1.19604754.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/configurator/vehicleimagenotavailable1.png
// module id = 146
// module chunks = 0